import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { NotificationItem, SseNotificationService } from 'src/app/core/services/sse-notification.service';
import { ToastService } from 'src/app/core/services/toast.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NotificationsComponent implements OnInit, OnDestroy {

  textHeading = 'Notifications';
  textBody = 'Centre de notifications';

  toutesNotifications: NotificationItem[] = [];
  filtre: 'toutes' | 'nonLues' = 'toutes';

  private souscription?: Subscription;

  constructor(
    private sse: SseNotificationService,
    private toast: ToastService
  ) {}

  ngOnInit(): void {
    this.souscription = this.sse.notifications$.subscribe(liste => {
      this.toutesNotifications = liste;
    });
  }

  ngOnDestroy(): void {
    this.souscription?.unsubscribe();
  }

  get notificationsFiltrees(): NotificationItem[] {
    if (this.filtre === 'nonLues') {
      return this.toutesNotifications.filter(n => !n.lu);
    }
    return this.toutesNotifications;
  }

  get nombreNonLues(): number {
    return this.toutesNotifications.filter(n => !n.lu).length;
  }

  marquerCommeLu(notification: NotificationItem): void {
    if (notification.lu) return;
    this.sse.marquerCommeLue(notification.id);
  }

  marquerToutCommeLu(): void {
    this.sse.marquerToutesCommeLues();
  }

  supprimerNotification(notification: NotificationItem): void {
    this.toast.confirmer(
      `Êtes-vous sûr de vouloir supprimer la notification "${notification.titre}" ?`,
      'Confirmer la suppression'
    ).subscribe(confirme => {
      if (confirme) this.sse.supprimer(notification.id);
    });
  }

  viderTout(): void {
    this.toast.confirmer(
      'Êtes-vous sûr de vouloir supprimer toutes les notifications ?',
      'Vider l\'historique'
    ).subscribe(confirme => {
      if (confirme) this.sse.viderTout();
    });
  }

  /** Format relatif simple : "il y a X minutes / heures / jours". */
  formatTemps(date: Date): string {
    const diff = Date.now() - new Date(date).getTime();
    const mins = Math.floor(diff / 60000);
    if (mins < 1) return "À l'instant";
    if (mins < 60) return `Il y a ${mins} min`;
    const h = Math.floor(mins / 60);
    if (h < 24) return `Il y a ${h} h`;
    const j = Math.floor(h / 24);
    return j === 1 ? 'Hier' : `Il y a ${j} jours`;
  }

  getTypeClass(type: string): string {
    const classMap: { [key: string]: string } = {
      NOUVELLE_COMMANDE: 'notification-info',
      STATUT_COMMANDE: 'notification-info',
      AFFECTATION_LIVREUR: 'notification-success',
      LIVRAISON_CONFIRMEE: 'notification-success',
      ALERTE: 'notification-warning',
      ERREUR: 'notification-error'
    };
    return classMap[type] || 'notification-info';
  }
}
